import React from 'react';
import PropTypes from 'prop-types';
import { PersonFillIcon, ImageIcon, CoinIcon } from '../../../model/icons';

// Карточка задания (.sp-task): фото, номер, метка цели, название, стоимость, мета.
// flaggedCount — число звеньев на проверке (для челленджей), показывает бейдж.
export default function TaskCard({ task, index, onClick, flaggedCount }) {
    const url = task.mediaFile?.mediaFileUrl;
    const limited = task.taskAvailableCountType === 'LIMIT';
    return (
        <div className={`sp-task${task.isActive === false ? ' off' : ''}`} role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
            <div className="sp-tphoto">
                <span className="sp-tnum">{index + 1}</span>
                {task.withTargetUser && <span className="sp-tperson"><PersonFillIcon /></span>}
                {flaggedCount > 0 && <span className="sp-tflag">на проверке: {flaggedCount}</span>}
                {url ? <img src={url} alt="" /> : <span className="ph"><ImageIcon /></span>}
            </div>
            <div className="sp-tinfo">
                <div className="sp-ttop">
                    <div className="sp-tname">{task.title}</div>
                    <div className="sp-tcost">{task.cost} <CoinIcon /></div>
                </div>
                {task.description && <div className="sp-tdesc">{task.description}</div>}
                <div className="sp-tmeta">
                    <span className="lim">{limited ? `осталось: ${task.availableCount ?? 0}` : 'безлимитно'}</span>
                    {task.isActive === false && <span className="lim">выключено</span>}
                </div>
            </div>
        </div>
    );
}

TaskCard.propTypes = {
    task: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    flaggedCount: PropTypes.number
};

TaskCard.defaultProps = { flaggedCount: 0 };
